var repeat = String.prototype.repeat && function (count, self) {
  return self.repeat(count);
} || function (count, self) {
  if (self.length == 0 || count == 0) {
    return '';
  } // Ensuring count is a 31-bit integer allows us to heavily optimize the
  // main part. But anyway, most current (August 2014) browsers can't handle
  // strings 1 << 28 chars or longer, so:


  if (self.length * count >= 1 << 28) {
    throw new RangeError('repeat count must not overflow maximum string size');
  }

  var rpt = '';

  for (;;) {
    if ((count & 1) == 1) {
      rpt += self;
    }

    count >>>= 1;

    if (count == 0) {
      break;
    }

    self += self;
  }

  return rpt;
};

export { repeat };
/* repeat Not a pure module */